import React from 'react'
import { twMerge } from 'tailwind-merge'

import { Box } from '../box'

export type DateOrTimePickerSimpleProps = {
    /** Inline picker content — typically a {@link CalendarSheet} or {@link TimePicker}. */
    children?: React.ReactNode
    className?: string
    testID?: string
}

/**
 * Bordered surface shell for the simple, inline (popover-less) picker variant
 * from the Figma redesign (AOS-621). An `elevation` panel with a subtle border
 * and clipped corners that hosts a {@link CalendarSheet} or {@link TimePicker}
 * directly inline rather than in a floating popover.
 */
export const DateOrTimePickerSimple: React.FC<DateOrTimePickerSimpleProps> = ({
    children,
    className,
    testID,
}) => (
    <Box
        className={twMerge(
            'flex-col items-start min-w-[256px] overflow-hidden rounded border border-border-subtle bg-aos-bg-elevation',
            className,
        )}
        testID={testID}
    >
        {children}
    </Box>
)

DateOrTimePickerSimple.displayName = 'DateOrTimePickerSimple'
